import React from "react";

const SuccessIcon = () => {
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 0.833328C7.18 0.833328 0.833336 7.17999 0.833336 15C0.833336 22.82 7.18 29.1667 15 29.1667C22.82 29.1667 29.1667 22.82 29.1667 15C29.1667 7.17999 22.82 0.833328 15 0.833328ZM12.1667 22.0833L5.08334 15L7.08084 13.0025L12.1667 18.0742L22.9192 7.32166L24.9167 9.33333L12.1667 22.0833Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export default SuccessIcon;
